// extracted by mini-css-extract-plugin
export var container = "commonStyles-module__container___oPS+1";
export var formContainer = "commonStyles-module__formContainer___g4N4M";
export var formWrapper = "commonStyles-module__formWrapper___0FZL8";
export var gameTitle = "commonStyles-module__gameTitle___GdLz1";
export var internalContainer = "commonStyles-module__internalContainer___QEtce";
export var largeTextBox = "commonStyles-module__largeTextBox___+kqVB";
export var pageContainer = "commonStyles-module__pageContainer___pTOIG";
export var primaryButton = "commonStyles-module__primaryButton___bnjt0";
export var rowContainer = "commonStyles-module__rowContainer___7NAT7";
export var secondaryButton = "commonStyles-module__secondaryButton___29NO-";
export var slimContainer = "commonStyles-module__slimContainer___cpM08";
export var spinnerContainer = "commonStyles-module__spinnerContainer___dMWyJ";
export var textField = "commonStyles-module__textField___JR93s";
export var textFieldLabel = "commonStyles-module__textFieldLabel___TzTRy";
export var textFieldMultiline = "commonStyles-module__textFieldMultiline___9sL5b";
export var textFieldMultilineWrapper = "commonStyles-module__textFieldMultilineWrapper___i33wF";
export var textFieldText = "commonStyles-module__textFieldText___puVkr";
export var titleStatusContainer = "commonStyles-module__titleStatusContainer___fGTTu";